module.exports = "/assets/5f73cc8979146b056d9097fd0939f2b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BR.png
// module id = 1240
// module chunks = 0